import './SearchFilters.css';

export interface FilterOption {
  value: string;
  label: string;
}

export interface FilterField {
  id: string;
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
}

interface SearchFiltersProps {
  search: string;
  onSearch: (value: string) => void;
  placeholder?: string;
  filters?: FilterField[];
}

export function SearchFilters({ search, onSearch, placeholder = 'Поиск', filters = [] }: SearchFiltersProps) {
  return (
    <form
      className="filters"
      action="#"
      onSubmit={(event) => {
        event.preventDefault();
      }}
    >
      <input
        className="filters__search"
        type="text"
        value={search}
        onChange={(event) => onSearch(event.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        enterKeyHint="search"
      />
      {filters.length > 0 ? (
        <div className="filters__row">
          {filters.map((field) => (
            <label key={field.id} className="filters__field">
              <select
                className="filters__select"
                value={field.value}
                onChange={(event) => field.onChange(event.target.value)}
              >
                {field.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </label>
          ))}
        </div>
      ) : null}
    </form>
  );
}

export function matchesQuery(haystack: Array<string | null | undefined>, query: string): boolean {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;
  return haystack.some((part) => (part ?? '').toLowerCase().includes(needle));
}
